import * as React from "react"
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"
import { GROUPED_BY } from "@constants"
import { normalizeLabel } from "../../utils"


export default function visionSplitColumn(label) {
	return {
		name: normalizeLabel(label),
		setBodyCellProps: () => ({ sx: { minWidth: '200px'} }),
		render: (value, {country, siteURL}) => {
			if (GROUPED_BY.COUNTRY === label)
				return <LabelCountry country={country} label={translateCountryName(country)} />
			if (GROUPED_BY.RETAILER === label)
				return <LabelCountry 
                    label={value} 
                    country={country}
					url={siteURL}
                />
			return value
		}
	}
}